<template>
  <DS>
    <LayoutSite
      :items="[
        { link: '#section--1', text: 'Модули' },
        { link: '#section--2', text: 'Возможности' },
        { link: '#section--3', text: 'Для кого' },
        { link: '#section--4', text: 'Внедрения' },
        { link: '#section--5', text: 'Поддержка' },
      ]"
    >
      <template #logo>
        <img
          v-if="theme === Themes.default && isScroll"
          :src="require(`@/assets/svg/logo_main.svg`)"
        />
        <img v-else :src="require(`@/assets/svg/logo_main--white.svg`)" />
      </template>

      <template #logo-gadgets>
        <img
          v-if="theme === Themes.default"
          :src="require(`@/assets/svg/logo_main.svg`)"
        />
        <img v-else :src="require(`@/assets/svg/logo_main--white.svg`)" />
      </template>

      <template #button>
        <Button
          class="layout__button"
          size="polyxo"
          @click.prevent="setModal('form')"
          >Заявка на подключение</Button
        >
      </template>

      <template #button-gadgets>
        <Button
          class="layout__gadgets-menu-button"
          size="helike"
          is-wide
          @click.prevent="setModal('form')"
          >Заявка на подключение</Button
        >
      </template>

      <template #landing>
        <section class="app__top" id="app__top">
          <div class="app__top-wrapper">
            <video
              v-if="isMounted"
              class="app__video"
              width="100%"
              height="100%"
              loop="true"
              autoplay
              muted
            >
              <source src="./assets/video/background.mp4" type="video/mp4" />
            </video>
          </div>

          <div class="app__top-overlay" />

          <Wrapper>
            <div class="app__wrapper-outer">
              <div class="app__wrapper">
                <div class="app__title">Цифровое ресурсоснабжение</div>
                <div class="app__text">
                  платформа для автоматизации основных бизнес-процессов<br
                    class="hidden--inline--gadgets"
                  /><span class="hidden--inline--desktops">&nbsp;</span
                  >ресурсоснабжающих предприятий и создания единого<br
                    class="hidden--inline--gadgets"
                  /><span class="hidden--inline--desktops">&nbsp;</span
                  >информационного пространства
                </div>

                <div class="app__wrapper-flex">
                  <Button size="laripha" @click.prevent="setModal('form')"
                    >Заказать демонстрацию</Button
                  >

                  <div class="app__video-button">
                    <Plank
                      title="Видеопрезентация"
                      subtitle="5:28, 140 Мб"
                      @click.prevent="setModal('video')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Wrapper>
        </section>
      </template>

      <main role="main">
        <section class="app__section app__section--product" id="section--1">
          <Wrapper>
            <div class="app__title">О продукте</div>
            <div class="app__subtitle">
              6 модулей для производства, эксплуатации, сбыта и управления
              ресурсоснабжением
            </div>
            <div class="app__grid">
              <div class="app__card">
                <div class="app__card-tag">Производство</div>
                <div class="app__card-header">Анализ режимов</div>
                <div class="app__card-text">
                  Модуль для мониторинга и анализа режимов работы оборудования,
                  отдельных сегментов сети, повышения качества и надёжности
                </div>
              </div>
              <div class="app__card">
                <div class="app__card-tag">Производство</div>
                <div class="app__card-header">Анализ балансов</div>
                <div class="app__card-text">
                  Модуль для выявления зон наибольших потерь и локализации
                  дисбаланса системы, сокращения коммерческих и технологических
                  потерь
                </div>
              </div>
              <div class="app__card">
                <div class="app__card-tag">Эксплуатация</div>
                <div class="app__card-header">Поддержка эксплуатации</div>
                <div class="app__card-text">
                  Модуль для повышения эффективности работы эксплуатационного
                  персонала на объектах предприятия
                </div>
              </div>
              <div class="app__card">
                <div class="app__card-tag">Эксплуатация</div>
                <div class="app__card-header">Заявки</div>
                <div class="app__card-text">
                  Модуль для повышения эффективности выполнения плановых и
                  аварийных ремонтных работ, использования транспортных средств
                  и спецтехники
                </div>
              </div>
              <div class="app__card">
                <div class="app__card-tag">Сбыт</div>
                <div class="app__card-header">Обходчик контролёр</div>
                <div class="app__card-text">
                  Модуль для автоматизации обследования абонентов, контроля
                  потребления ресурсов
                </div>
              </div>
              <div class="app__card">
                <div class="app__card-tag">Управление</div>
                <div class="app__card-header">Центральная панель</div>
                <div class="app__card-text">
                  Модуль для умного визуального представления ключевых
                  показателей через систему гибко настраиваемых панелей
                  индикаторов
                </div>
              </div>
            </div>
          </Wrapper>
        </section>

        <section class="app__section app__section--slider">
          <Wrapper class="hidden--block--middle">
            <div class="app__slider">
              <Carousel v-bind="screenshotsCarouselConfig" :key="slider">
                <Slide v-for="slide in 9" :key="slide">
                  <div :class="`app__slide app__slide--${slide}`" />
                </Slide>

                <template #addons>
                  <Navigation>
                    <template #prev>
                      <div class="app__arrow-left">
                        <svg
                          class="visible--block--narrow"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="32" height="32" rx="16" fill="white" />
                          <path
                            d="M18.8378 10.0416C19.1368 9.57729 19.0028 8.95846 18.5385 8.65941C18.3708 8.55135 18.1828 8.49983 17.9971 8.5C17.6688 8.5003 17.3473 8.66209 17.1563 8.95864L13.6673 14.3757C13.6656 14.3783 13.6639 14.3809 13.6623 14.3835L13.3186 14.9172C12.8938 15.5767 12.8938 16.4236 13.3186 17.0831L13.6623 17.6168C13.664 17.6194 13.6656 17.622 13.6673 17.6246L17.1563 23.0416C17.2685 23.2157 17.4256 23.3434 17.6027 23.4192C17.8524 23.5261 18.1417 23.5298 18.4007 23.4152C18.4478 23.3944 18.4939 23.3696 18.5385 23.3408C19.0029 23.0418 19.1368 22.4229 18.8378 21.9586L15.3487 16.5416C15.3478 16.5401 15.3468 16.5386 15.3458 16.5371C15.1373 16.2095 15.1373 15.7908 15.3458 15.4632L18.8378 10.0416Z"
                            fill="#80858E"
                          />
                        </svg>
                        <svg
                          class="hidden--block--narrow"
                          width="48"
                          height="48"
                          viewBox="0 0 48 48"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="48" height="48" rx="24" fill="white" />
                          <path
                            d="M29.8255 9.56267C30.1362 9.10607 30.018 8.48405 29.5614 8.17335C29.3892 8.05617 29.1934 8.00001 28.9997 8C28.6797 7.9998 28.3651 8.15296 28.1715 8.43753L18.7302 22.3124C18.7202 22.3271 18.7103 22.3419 18.7005 22.3568L18.348 22.875C17.886 23.5539 17.886 24.4463 18.348 25.1252L18.7006 25.6434C18.7103 25.6583 18.7202 25.6731 18.7302 25.6878L28.1715 39.5627C28.3651 39.8472 28.6797 40.0004 28.9997 40.0002C29.1934 40.0002 29.3892 39.944 29.5614 39.8268C30.018 39.5161 30.1362 38.8941 29.8255 38.4375L20.3667 24.5369C20.1583 24.2095 20.1584 23.7907 20.3668 23.4633L29.8255 9.56267Z"
                            fill="#80858E"
                          />
                        </svg>
                      </div>
                    </template>
                    <template #next>
                      <div class="app__arrow-right">
                        <svg
                          class="visible--block--narrow"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="32" height="32" rx="16" fill="white" />
                          <g clip-path="url(#clip0_926_2355)">
                            <path
                              d="M13.1623 10.0416C12.8633 9.57729 12.9973 8.95846 13.4616 8.65941C13.6293 8.55135 13.8173 8.49983 14.003 8.5C14.3313 8.5003 14.6528 8.66209 14.8438 8.95864L18.3328 14.3757C18.3345 14.3783 18.3362 14.3809 18.3378 14.3835L18.6815 14.9172C19.1063 15.5767 19.1063 16.4236 18.6815 17.0831L18.3378 17.6168C18.3361 17.6194 18.3345 17.622 18.3328 17.6246L14.8438 23.0416C14.7316 23.2157 14.5745 23.3434 14.3974 23.4192C14.1477 23.5261 13.8584 23.5298 13.5994 23.4152C13.5523 23.3944 13.5062 23.3696 13.4616 23.3408C12.9973 23.0418 12.8633 22.4229 13.1623 21.9586L16.6514 16.5416C16.6523 16.5401 16.6533 16.5386 16.6543 16.5371C16.8628 16.2095 16.8628 15.7908 16.6543 15.4632L13.1623 10.0416Z"
                              fill="#80858E"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_926_2355">
                              <rect
                                width="6"
                                height="16"
                                fill="white"
                                transform="translate(13 8)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        <svg
                          class="hidden--block--narrow"
                          width="48"
                          height="48"
                          viewBox="0 0 48 48"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="48" height="48" rx="24" fill="white" />
                          <path
                            d="M18.1748 9.56267C17.8641 9.10607 17.9824 8.48405 18.439 8.17335C18.6112 8.05617 18.8069 8.00001 19.0006 8C19.3207 7.9998 19.6352 8.15296 19.8289 8.43753L29.2702 22.3124C29.2802 22.3271 29.2901 22.3419 29.2998 22.3568L29.6524 22.875C30.1144 23.5539 30.1144 24.4463 29.6524 25.1252L29.2998 25.6434C29.2901 25.6583 29.2802 25.6731 29.2702 25.6878L19.8289 39.5627C19.6352 39.8472 19.3207 40.0004 19.0006 40.0002C18.8069 40.0002 18.6112 39.944 18.439 39.8268C17.9824 39.5161 17.8641 38.8941 18.1748 38.4375L27.6336 24.5369C27.842 24.2095 27.842 23.7907 27.6336 23.4633L18.1748 9.56267Z"
                            fill="#80858E"
                          />
                        </svg>
                      </div>
                    </template>
                  </Navigation>
                  <Pagination />
                </template>
              </Carousel>
            </div>
          </Wrapper>
          <div class="app__slider visible--block--middle">
            <Carousel v-bind="screenshotsCarouselConfig" :key="slider">
              <Slide v-for="slide in 9" :key="slide">
                <div :class="`app__slide app__slide--${slide}`" />
              </Slide>

              <template #addons>
                <Navigation>
                  <template #prev>
                    <div class="app__arrow-left">
                      <svg
                        class="visible--block--narrow"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="32" height="32" rx="16" fill="white" />
                        <path
                          d="M18.8378 10.0416C19.1368 9.57729 19.0028 8.95846 18.5385 8.65941C18.3708 8.55135 18.1828 8.49983 17.9971 8.5C17.6688 8.5003 17.3473 8.66209 17.1563 8.95864L13.6673 14.3757C13.6656 14.3783 13.6639 14.3809 13.6623 14.3835L13.3186 14.9172C12.8938 15.5767 12.8938 16.4236 13.3186 17.0831L13.6623 17.6168C13.664 17.6194 13.6656 17.622 13.6673 17.6246L17.1563 23.0416C17.2685 23.2157 17.4256 23.3434 17.6027 23.4192C17.8524 23.5261 18.1417 23.5298 18.4007 23.4152C18.4478 23.3944 18.4939 23.3696 18.5385 23.3408C19.0029 23.0418 19.1368 22.4229 18.8378 21.9586L15.3487 16.5416C15.3478 16.5401 15.3468 16.5386 15.3458 16.5371C15.1373 16.2095 15.1373 15.7908 15.3458 15.4632L18.8378 10.0416Z"
                          fill="#80858E"
                        />
                      </svg>
                      <svg
                        class="hidden--block--narrow"
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="48" height="48" rx="24" fill="white" />
                        <path
                          d="M29.8255 9.56267C30.1362 9.10607 30.018 8.48405 29.5614 8.17335C29.3892 8.05617 29.1934 8.00001 28.9997 8C28.6797 7.9998 28.3651 8.15296 28.1715 8.43753L18.7302 22.3124C18.7202 22.3271 18.7103 22.3419 18.7005 22.3568L18.348 22.875C17.886 23.5539 17.886 24.4463 18.348 25.1252L18.7006 25.6434C18.7103 25.6583 18.7202 25.6731 18.7302 25.6878L28.1715 39.5627C28.3651 39.8472 28.6797 40.0004 28.9997 40.0002C29.1934 40.0002 29.3892 39.944 29.5614 39.8268C30.018 39.5161 30.1362 38.8941 29.8255 38.4375L20.3667 24.5369C20.1583 24.2095 20.1584 23.7907 20.3668 23.4633L29.8255 9.56267Z"
                          fill="#80858E"
                        />
                      </svg>
                    </div>
                  </template>
                  <template #next>
                    <div class="app__arrow-right">
                      <svg
                        class="visible--block--narrow"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="32" height="32" rx="16" fill="white" />
                        <g clip-path="url(#clip0_926_2355)">
                          <path
                            d="M13.1623 10.0416C12.8633 9.57729 12.9973 8.95846 13.4616 8.65941C13.6293 8.55135 13.8173 8.49983 14.003 8.5C14.3313 8.5003 14.6528 8.66209 14.8438 8.95864L18.3328 14.3757C18.3345 14.3783 18.3362 14.3809 18.3378 14.3835L18.6815 14.9172C19.1063 15.5767 19.1063 16.4236 18.6815 17.0831L18.3378 17.6168C18.3361 17.6194 18.3345 17.622 18.3328 17.6246L14.8438 23.0416C14.7316 23.2157 14.5745 23.3434 14.3974 23.4192C14.1477 23.5261 13.8584 23.5298 13.5994 23.4152C13.5523 23.3944 13.5062 23.3696 13.4616 23.3408C12.9973 23.0418 12.8633 22.4229 13.1623 21.9586L16.6514 16.5416C16.6523 16.5401 16.6533 16.5386 16.6543 16.5371C16.8628 16.2095 16.8628 15.7908 16.6543 15.4632L13.1623 10.0416Z"
                            fill="#80858E"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_926_2355">
                            <rect
                              width="6"
                              height="16"
                              fill="white"
                              transform="translate(13 8)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <svg
                        class="hidden--block--narrow"
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="48" height="48" rx="24" fill="white" />
                        <path
                          d="M18.1748 9.56267C17.8641 9.10607 17.9824 8.48405 18.439 8.17335C18.6112 8.05617 18.8069 8.00001 19.0006 8C19.3207 7.9998 19.6352 8.15296 19.8289 8.43753L29.2702 22.3124C29.2802 22.3271 29.2901 22.3419 29.2998 22.3568L29.6524 22.875C30.1144 23.5539 30.1144 24.4463 29.6524 25.1252L29.2998 25.6434C29.2901 25.6583 29.2802 25.6731 29.2702 25.6878L19.8289 39.5627C19.6352 39.8472 19.3207 40.0004 19.0006 40.0002C18.8069 40.0002 18.6112 39.944 18.439 39.8268C17.9824 39.5161 17.8641 38.8941 18.1748 38.4375L27.6336 24.5369C27.842 24.2095 27.842 23.7907 27.6336 23.4633L18.1748 9.56267Z"
                          fill="#80858E"
                        />
                      </svg>
                    </div>
                  </template>
                </Navigation>
                <Pagination />
              </template>
            </Carousel>
          </div>
        </section>

        <section class="app__section app__section--color app__section--color1">
          <Wrapper>
            <div class="app__color app__color--1">
              <div class="app__color-wrapper-outer visible--flex--widest">
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--1">
                      <div>
                        Управление ресурсами<br />на основе «больших данных»
                      </div>
                    </div>
                    <div class="app__color-block app__color-block--2">
                      <div>
                        Математическое моделирование<br />и машинное обучение
                      </div>
                    </div>
                    <div class="app__color-block app__color-block--3">
                      <div>Мобильные<br />технологии</div>
                    </div>
                  </div>
                </div>
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--4">
                      <div>
                        Аналитика и роботизация оцифрованных<br />бизнес-процессов
                        предприятия
                      </div>
                    </div>
                    <div class="app__color-block app__color-block--5">
                      <div>
                        Цифровой контроль за выполнением<br />измеримых
                        показателей
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="app__color-wrapper-outer visible--flex--wide">
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--1">
                      <div>
                        Управление ресурсами<br />на основе «больших данных»
                      </div>
                    </div>
                    <div class="app__color-block app__color-block--2">
                      <div>
                        Математическое моделирование<br />и машинное обучение
                      </div>
                    </div>
                  </div>
                </div>
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--3">
                      <div>Мобильные<br />технологии</div>
                    </div>
                    <div class="app__color-block app__color-block--4">
                      <div>
                        Аналитика и роботизация оцифрованных<br />бизнес-процессов
                        предприятия
                      </div>
                    </div>
                  </div>
                </div>
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--5">
                      <div>
                        Цифровой контроль за выполнением<br />измеримых
                        показателей
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="app__color-wrapper-outer visible--flex--middle">
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--1">
                      <div>
                        Управление ресурсами<br />на основе «больших данных»
                      </div>
                    </div>
                  </div>
                </div>
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--2">
                      <div>
                        Математическое моделирование<br />и машинное обучение
                      </div>
                    </div>
                  </div>
                </div>
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--3">
                      <div>Мобильные<br />технологии</div>
                    </div>
                    <div class="app__color-block app__color-block--4">
                      <div>
                        Аналитика и роботизация оцифрованных<br />бизнес-процессов
                        предприятия
                      </div>
                    </div>
                  </div>
                </div>
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--5">
                      <div>
                        Цифровой контроль за выполнением<br />измеримых
                        показателей
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="app__color-wrapper-outer visible--flex--narrow">
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--1">
                      <div>
                        Управление ресурсами<br />на основе «больших данных»
                      </div>
                    </div>
                  </div>
                </div>
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--2">
                      <div>
                        Математическое моделирование<br />и машинное обучение
                      </div>
                    </div>
                  </div>
                </div>
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--3">
                      <div>Мобильные<br />технологии</div>
                    </div>
                  </div>
                </div>
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--4">
                      <div>
                        Аналитика и роботизация<br />оцифрованных бизнес-<br />процессов
                        предприятия
                      </div>
                    </div>
                  </div>
                </div>
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--5">
                      <div>
                        Цифровой контроль за выполнением<br />измеримых
                        показателей
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Wrapper>
        </section>

        <section
          class="app__section app__section--possibilities"
          id="section--2"
        >
          <Wrapper>
            <div class="app__title">Возможности</div>

            <div class="visible--block--desktops">
              <div class="app__grid app__grid--1">
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos1" />
                  <div class="app__card-header">Обработка данных</div>
                  <div class="app__card-text">
                    технологических параметров работы объектов
                  </div>
                </div>
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos2" />
                  <div class="app__card-header">Расчёт и мониторинг</div>
                  <div class="app__card-text">
                    эффективности работы оборудования объектов
                  </div>
                </div>
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos3" />
                  <div class="app__card-header">Управление</div>
                  <div class="app__card-text">
                    ремонтными и аварийными работами
                  </div>
                </div>
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos4" />
                  <div class="app__card-header">Автоматизация работы</div>
                  <div class="app__card-text">
                    оперативного персонала на объектах предприятия
                  </div>
                </div>
              </div>
              <div class="app__grid app__grid--2">
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos5" />
                  <div class="app__card-header">Автоматизация процессов</div>
                  <div class="app__card-text">
                    взаимодействия с потребителями и персоналом
                  </div>
                </div>
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos6" />
                  <div class="app__card-header">План-факторный анализ</div>
                  <div class="app__card-text">
                    объёмов ресурса от источника до потребителя
                  </div>
                </div>
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos7" />
                  <div class="app__card-header">
                    Интеллектуальное представление
                  </div>
                  <div class="app__card-text">
                    ключевых показателей эффективности
                  </div>
                </div>
              </div>
            </div>

            <div class="visible--block--middle">
              <div class="app__grid app__grid--1">
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos1" />
                  <div class="app__card-header">Обработка данных</div>
                  <div class="app__card-text">
                    технологических параметров работы объектов
                  </div>
                </div>
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos2" />
                  <div class="app__card-header">Расчёт и мониторинг</div>
                  <div class="app__card-text">
                    эффективности работы оборудования объектов
                  </div>
                </div>
              </div>
              <div class="app__grid--3">
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos3" />
                  <div class="app__card-header">Управление</div>
                  <div class="app__card-text">
                    ремонтными и аварийными работами
                  </div>
                </div>
              </div>
              <div class="app__grid app__grid--2">
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos4" />
                  <div class="app__card-header">Автоматизация работы</div>
                  <div class="app__card-text">
                    оперативного персонала на объектах предприятия
                  </div>
                </div>
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos5" />
                  <div class="app__card-header">Автоматизация процессов</div>
                  <div class="app__card-text">
                    взаимодействия с потребителями и персоналом
                  </div>
                </div>
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos6" />
                  <div class="app__card-header">План-факторный анализ</div>
                  <div class="app__card-text">
                    объёмов ресурса от источника до потребителя
                  </div>
                </div>
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos7" />
                  <div class="app__card-header">
                    Интеллектуальное представление
                  </div>
                  <div class="app__card-text">
                    ключевых показателей эффективности
                  </div>
                </div>
              </div>
            </div>

            <div class="visible--block--narrow">
              <div class="app__grid app__grid--1">
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos1" />
                  <div class="app__card-header">Обработка данных</div>
                  <div class="app__card-text">
                    технологических параметров работы объектов
                  </div>
                </div>
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos2" />
                  <div class="app__card-header">Расчёт и мониторинг</div>
                  <div class="app__card-text">
                    эффективности работы оборудования объектов
                  </div>
                </div>
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos3" />
                  <div class="app__card-header">Управление</div>
                  <div class="app__card-text">
                    ремонтными и аварийными работами
                  </div>
                </div>
              </div>
              <div class="app__grid app__grid--2">
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos4" />
                  <div class="app__card-header">Автоматизация работы</div>
                  <div class="app__card-text">
                    оперативного персонала на объектах предприятия
                  </div>
                </div>
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos5" />
                  <div class="app__card-header">Автоматизация процессов</div>
                  <div class="app__card-text">
                    взаимодействия с потребителями и персоналом
                  </div>
                </div>
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos6" />
                  <div class="app__card-header">План-факторный анализ</div>
                  <div class="app__card-text">
                    объёмов ресурса от источника до потребителя
                  </div>
                </div>
                <div class="app__card">
                  <Icon class="app__card-icon" name="pos7" />
                  <div class="app__card-header">
                    Интеллектуальное представление
                  </div>
                  <div class="app__card-text">
                    ключевых показателей эффективности
                  </div>
                </div>
              </div>
            </div>
          </Wrapper>
        </section>

        <section class="app__section app__section--national">
          <Wrapper>
            <div class="app__title">
              Соответствует национальным целям и стандартам
            </div>

            <div class="app__grid app__grid--1 hidden--grid--narrow">
              <div class="app__card2">
                <div class="app__card-header2">Указ Президента РФ №166</div>
                <div class="app__card-text2">
                  Улучшение качества и надежности обеспечения теплом и ГВС
                  населения, снижение потребления энергоресурсов, снижение
                  количества аварий, повышение эффективности и прозрачности
                  процессов теплоснабжения
                </div>
              </div>
              <div class="app__card2">
                <div class="app__card-header2">Указ Президента РФ №474</div>
                <div class="app__card-text2">
                  О национальных целях развития Российской Федерации на период
                  до 2030 года
                </div>
              </div>
              <div class="app__card2">
                <div class="app__card-header2">Указ Минстроя РФ №357/пр.</div>
                <div class="app__card-text2">
                  Перечень базовых и дополнительных показателей цифровизации
                  городского хозяйства — Стандарт «Умного города»
                </div>
              </div>
              <div class="app__card2">
                <div class="app__card-header2">УГТ 9</div>
                <div class="app__card-text2">
                  Соответствие ГОСТ Р 58048-2017. Удовлетворяет всем
                  требованиям: инженерным, производственным, эксплуатационным,
                  по качеству и надежности
                </div>
              </div>
            </div>
          </Wrapper>

          <Carousel
            class="app__mobile-slider1 visible--block--narrow"
            v-bind="nationalStandardsCarouselConfig"
            :key="slider"
          >
            <Slide>
              <div class="app__card2 app__card2--in-slide">
                <div class="app__card-header2">Указ Президента РФ №166</div>
                <div class="app__card-text2">
                  Улучшение качества и надежности обеспечения теплом и ГВС
                  населения, снижение потребления энергоресурсов, снижение
                  количества аварий, повышение эффективности и прозрачности
                  процессов теплоснабжения
                </div>
              </div>
            </Slide>
            <Slide>
              <div class="app__card2 app__card2--in-slide">
                <div class="app__card-header2">Указ Президента РФ №474</div>
                <div class="app__card-text2">
                  О национальных целях развития Российской Федерации на период
                  до 2030 года
                </div>
              </div>
            </Slide>
            <Slide>
              <div class="app__card2 app__card2--in-slide">
                <div class="app__card-header2">Указ Минстроя РФ №357/пр.</div>
                <div class="app__card-text2">
                  Перечень базовых и дополнительных показателей цифровизации
                  городского хозяйства — Стандарт «Умного города»
                </div>
              </div>
            </Slide>
            <Slide>
              <div class="app__card2 app__card2--in-slide">
                <div class="app__card-header2">УГТ 9</div>
                <div class="app__card-text2">
                  Соответствие ГОСТ Р 58048-2017. Удовлетворяет всем
                  требованиям: инженерным, производственным, эксплуатационным,
                  по качеству и надежности
                </div>
              </div>
            </Slide>
            <template #addons>
              <Navigation>
                <template #prev> </template>
                <template #next> </template>
              </Navigation>
              <Pagination />
            </template>
          </Carousel>

          <Wrapper>
            <div class="app__grid app__grid--2">
              <div class="app__card3">
                <Icon class="app__card-icon" name="nat1" />
                <div class="app__card-header app__card-header--info">
                  Сделано в России<a
                    href=""
                    class="app__card-info"
                    @click.prevent="tryClick"
                  >
                    <Icon name="info" />
                  </a>
                  <div
                    v-if="isPopup1"
                    class="app__popup"
                    v-click-outside="onClickOutside"
                  >
                    Запись в Российском реестре программного обеспечения №11959
                    от 29.10.2021 произведена на основании приказа Министерства
                    цифрового развития, связи и массовых коммуникаций Российской
                    Федерации от 28.10.2021 №1105
                  </div>
                </div>
                <div class="app__card-text">
                  100% российское решение, зарегистрированное в реестре
                  отечественного ПО
                </div>
              </div>
              <div class="app__card3">
                <Icon class="app__card-icon" name="nat2" />
                <div class="app__card-header">Продукт Росатома</div>
                <div class="app__card-text">
                  Разработано Госкорпорацией — ключевым участником национального
                  проекта «Цифровая экономика»
                </div>
              </div>
              <div class="app__card3">
                <Icon class="app__card-icon" name="nat3" />
                <div class="app__card-header">Импортозамещение</div>
                <div class="app__card-text">
                  Продукт выполняет функции подобных программных решений
                  иностранных производителей
                </div>
              </div>
            </div>
          </Wrapper>
        </section>

        <section class="app__section app__section--clients" id="section--3">
          <Wrapper>
            <div class="app__title">Наши заказчики</div>

            <div class="app__grid">
              <div class="app__card3">
                <Icon class="app__card-icon" name="industrial" />
                <div class="app__card-subheader">
                  ЖКХ (тепло- и водоснабжение) и теплоэнергетика
                </div>
                <div class="app__card-header">
                  Ресурсоснабжающие организации
                </div>
                <ul class="app__card-list">
                  <li>Повышение качества предоставляемых услуг</li>
                  <li>
                    Повышение эффективности работы технологических объектов
                  </li>
                  <li>
                    Снижение технических и коммерческих потерь поставляемого
                    ресурса
                  </li>
                </ul>
              </div>
              <div class="app__card3">
                <Icon class="app__card-icon" name="school" />
                <div class="app__card-subheader">
                  Горячее и холодное водоснабжение, теплоснабжение
                </div>
                <div class="app__card-header">Потребители — население</div>
                <ul class="app__card-list">
                  <li>
                    Рост качества услуг, обслуживания и прозрачности в
                    современных условиях
                  </li>
                  <li>
                    Рост оперативности реагирования ремонтных служб на обращения
                  </li>
                  <li>Сокращение перерывов в подаче ресурсов</li>
                </ul>
              </div>
              <div class="app__card3">
                <Icon class="app__card-icon" name="admin" />
                <div class="app__card-subheader">Муниципалитеты</div>
                <div class="app__card-header">Органы власти</div>
                <ul class="app__card-list">
                  <li>
                    Повышение эффективности работы систем тепло- и водоснабжения
                  </li>
                  <li>
                    Получение обратной связи для взаимодействия с потребителями
                  </li>
                  <li>
                    Оптимизация формирования ремонтных и инвестиционных программ
                  </li>
                </ul>
              </div>
            </div>
          </Wrapper>
        </section>

        <section class="app__section app__section--color app__section--color2">
          <Wrapper>
            <div class="app__color app__color--2">
              <div class="app__color-wrapper-outer visible--block--widest">
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--6">
                      <div>
                        Достоверные данные для стратегического<br />управления и
                        мониторинга
                      </div>
                    </div>
                    <div class="app__color-block app__color-block--7">
                      <div>
                        Повышение эффективности технологического<br />оборудования
                        и сокращение потерь поставляемого ресурса
                      </div>
                    </div>
                  </div>
                </div>
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--8">
                      <div>
                        Увеличение положительных отзывов и снижение
                        негативных<br />настроений Населения по услугам
                        ресурсоснабжения
                      </div>
                    </div>
                    <div class="app__color-block app__color-block--9">
                      <div>Прозрачность<br />при оказании услуг</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="app__color-wrapper-outer hidden--block--widest">
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--6">
                      <div class="hidden--flex--narrow">
                        Достоверные данные для<br />стратегического управления и
                        мониторинга
                      </div>
                      <div class="visible--flex--narrow">
                        Достоверные данные<br />для стратегического<br />управления
                        и мониторинга
                      </div>
                    </div>
                  </div>
                </div>
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--7">
                      <div class="hidden--flex--narrow">
                        Повышение эффективности технологического<br />оборудования
                        и сокращение потерь поставляемого ресурса
                      </div>
                      <div class="visible--flex--narrow">
                        Повышение эффективности<br />технологического
                        оборудования<br />
                        и сокращение потерь<br />поставляемого ресурса
                      </div>
                    </div>
                  </div>
                </div>
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--8">
                      <div class="hidden--flex--narrow">
                        Увеличение положительных отзывов и снижение
                        негативных<br />настроений Населения по услугам
                        ресурсоснабжения
                      </div>
                      <div class="visible--flex--narrow">
                        Увеличение положительных<br />отзывов и снижение
                        негативных<br />настроений Населения по<br />услугам
                        ресурсоснабжения
                      </div>
                    </div>
                  </div>
                </div>
                <div class="app__color-wrapper">
                  <div class="app__color-wrapper-inner">
                    <div class="app__color-block app__color-block--9">
                      <div>Прозрачность<br />при оказании услуг</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Wrapper>
        </section>

        <section class="app__section app__section--map" id="section--4">
          <div
            class="app__map"
            :class="{
              'app__map--dark': theme !== Themes.default,
            }"
          />

          <div class="app__not-map">
            <Wrapper>
              <div class="app__title">Внедрения</div>
              <div class="app__subtitle">
                Платформа успешно работает в 8 городах
              </div>

              <div class="visible--block--desktops">
                <div class="app__grid">
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--1">
                      <div />
                    </div>
                    <div class="app__card5-header3">Краснодар</div>
                    <div class="app__card-subheader">
                      Цифровизация теплоснабжения
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--2">
                      <div />
                    </div>
                    <div class="app__card5-header3">Воронеж</div>
                    <div class="app__card-subheader">
                      Цифровизация теплоснабжения с полевым уровнем
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--3">
                      <div />
                    </div>
                    <div class="app__card5-header3">Липецк</div>
                    <div class="app__card-subheader">
                      Цифровизация теплоснабжения
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--4">
                      <div />
                    </div>
                    <div class="app__card5-header3">Белгород</div>
                    <div class="app__card-subheader">
                      Цифровизация водоснабжения с полевым уровнем
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--5">
                      <div />
                    </div>
                    <div class="app__card5-header3">Обнинск</div>
                    <div class="app__card-subheader">
                      Цифровизация тепло- и водоснабжения с полевым уровнем
                    </div>
                  </div>
                </div>
                <div class="app__grid">
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--6">
                      <div />
                    </div>
                    <div class="app__card5-header3">Курчатов</div>
                    <div class="app__card-subheader">
                      Цифровизация теплоснабжения с полевым уровнем
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--7">
                      <div />
                    </div>
                    <div class="app__card5-header3">Глазов</div>
                    <div class="app__card-subheader">
                      Цифровизация тепло- и водоснабжения с полевым уровнем
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--8">
                      <div />
                    </div>
                    <div class="app__card5-header3">Заречный</div>
                    <div class="app__card-subheader">
                      Цифровизация водоснабжения
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--9">
                      <div />
                    </div>
                    <div class="app__card5-header3">Ваш город</div>
                    <div class="app__card-subheader">Скоро</div>
                  </div>
                </div>
              </div>

              <div class="visible--block--middle">
                <div class="app__grid">
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--1">
                      <div />
                    </div>
                    <div class="app__card5-header3">Краснодар</div>
                    <div class="app__card-subheader">
                      Цифровизация теплоснабжения
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--2">
                      <div />
                    </div>
                    <div class="app__card5-header3">Воронеж</div>
                    <div class="app__card-subheader">
                      Цифровизация теплоснабжения с полевым уровнем
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--3">
                      <div />
                    </div>
                    <div class="app__card5-header3">Липецк</div>
                    <div class="app__card-subheader">
                      Цифровизация теплоснабжения
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--4">
                      <div />
                    </div>
                    <div class="app__card5-header3">Белгород</div>
                    <div class="app__card-subheader">
                      Цифровизация водоснабжения с полевым уровнем
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--5">
                      <div />
                    </div>
                    <div class="app__card5-header3">Обнинск</div>
                    <div class="app__card-subheader">
                      Цифровизация тепло- и водоснабжения с полевым уровнем
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--6">
                      <div />
                    </div>
                    <div class="app__card5-header3">Курчатов</div>
                    <div class="app__card-subheader">
                      Цифровизация теплоснабжения с полевым уровнем
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--7">
                      <div />
                    </div>
                    <div class="app__card5-header3">Глазов</div>
                    <div class="app__card-subheader">
                      Цифровизация тепло- и водоснабжения с полевым уровнем
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--8">
                      <div />
                    </div>
                    <div class="app__card5-header3">Заречный</div>
                    <div class="app__card-subheader">
                      Цифровизация водоснабжения
                    </div>
                  </div>
                  <div class="app__card5">
                    <div class="app__card-logo app__card-logo--9">
                      <div />
                    </div>
                    <div class="app__card5-header3">Ваш город</div>
                    <div class="app__card-subheader">Скоро</div>
                  </div>
                </div>
              </div>
            </Wrapper>

            <Carousel
              class="app__mobile-slider1 visible--block--narrow"
              v-bind="citiesCarouselconfig"
              :key="slider"
            >
              <Slide>
                <div class="app__card5">
                  <div class="app__card-logo app__card-logo--1">
                    <div />
                  </div>
                  <div class="app__card5-header3">Краснодар</div>
                  <div class="app__card-subheader">
                    Цифровизация теплоснабжения
                  </div>
                </div>
              </Slide>
              <Slide>
                <div class="app__card5">
                  <div class="app__card-logo app__card-logo--2">
                    <div />
                  </div>
                  <div class="app__card5-header3">Воронеж</div>
                  <div class="app__card-subheader">
                    Цифровизация теплоснабжения с полевым уровнем
                  </div>
                </div>
              </Slide>
              <Slide>
                <div class="app__card5">
                  <div class="app__card-logo app__card-logo--3">
                    <div />
                  </div>
                  <div class="app__card5-header3">Липецк</div>
                  <div class="app__card-subheader">
                    Цифровизация теплоснабжения
                  </div>
                </div>
              </Slide>
              <Slide>
                <div class="app__card5">
                  <div class="app__card-logo app__card-logo--4">
                    <div />
                  </div>
                  <div class="app__card5-header3">Белгород</div>
                  <div class="app__card-subheader">
                    Цифровизация водоснабжения с полевым уровнем
                  </div>
                </div>
              </Slide>
              <Slide>
                <div class="app__card5">
                  <div class="app__card-logo app__card-logo--5">
                    <div />
                  </div>
                  <div class="app__card5-header3">Обнинск</div>
                  <div class="app__card-subheader">
                    Цифровизация тепло- и водоснабжения с полевым уровнем
                  </div>
                </div>
              </Slide>
              <Slide>
                <div class="app__card5">
                  <div class="app__card-logo app__card-logo--6">
                    <div />
                  </div>
                  <div class="app__card5-header3">Курчатов</div>
                  <div class="app__card-subheader">
                    Цифровизация теплоснабжения с полевым уровнем
                  </div>
                </div>
              </Slide>
              <Slide>
                <div class="app__card5">
                  <div class="app__card-logo app__card-logo--7">
                    <div />
                  </div>
                  <div class="app__card5-header3">Глазов</div>
                  <div class="app__card-subheader">
                    Цифровизация тепло- и водоснабжения с полевым уровнем
                  </div>
                </div>
              </Slide>
              <Slide>
                <div class="app__card5">
                  <div class="app__card-logo app__card-logo--8">
                    <div />
                  </div>
                  <div class="app__card5-header3">Заречный</div>
                  <div class="app__card-subheader">
                    Цифровизация водоснабжения
                  </div>
                </div>
              </Slide>
              <Slide>
                <div class="app__card5">
                  <div class="app__card-logo app__card-logo--9">
                    <div />
                  </div>
                  <div class="app__card5-header3">Ваш город</div>
                  <div class="app__card-subheader">Скоро</div>
                </div>
              </Slide>
              <template #addons>
                <Navigation>
                  <template #prev> </template>
                  <template #next> </template>
                </Navigation>
                <Pagination />
              </template>
            </Carousel>
          </div>
        </section>

        <section class="app__section app__section--individual">
          <Wrapper>
            <div class="app__title">
              Индивидуальный подход к каждому заказчику
            </div>

            <div class="app__grid">
              <div class="app__card4 app__card4--blue">
                <div class="app__card-header">Поставка лицензии ПО</div>
                <div class="app__card-text">
                  Простая неисключительная лицензия по условиям заключенного
                  лицензионного договора
                </div>
              </div>
              <div class="app__card4 app__card4--orange">
                <div class="app__card-header">Внедрение ПО</div>
                <div class="app__card-text">
                  Платформа в полном объёме или ее отдельные модули
                </div>
              </div>
              <div class="app__card4 app__card4--red">
                <div class="app__card-header">Комплексное внедрение</div>
                <div class="app__card-text">
                  Обследование технологических объектов с дальнейшими работами
                  по проектированию поставкой оборудования его СМР и ПНР включая
                  внедрение ПО
                </div>
              </div>
            </div>
          </Wrapper>
        </section>

        <section class="app__section app__section--support" id="section--5">
          <Wrapper>
            <div class="app__section-header">
              <div class="app__title">Техническая поддержка</div>
              <div class="app__subtitle">
                Не бросаем заказчика после внедрения
              </div>
              <ButtonAction
                class="app__section-header-link"
                color="rocky"
                icon="file"
                :link="`./Terms_of_Support.pdf`"
                >Полный список предоставляемых&nbsp;
                <span class="hidden--inline--narrow">услуг</span
                ><span class="visible--inline--narrow">...</span></ButtonAction
              >
            </div>

            <div class="app__grid">
              <div class="app__card6 app__card6--blue">
                <div class="app__card-header">Общая</div>
                <div class="app__card-block app__card-block--1">
                  <div class="app__card-subheader">Кому предоставляется</div>
                  <div class="app__card-text">
                    Потенциальные и коммерческие пользователи ПО
                  </div>
                </div>
                <div class="app__card-line" />
                <div
                  class="app__card-block app__card-block--2 app__card-block--4"
                >
                  <div class="app__card-subheader">Стоимость</div>
                  <div class="app__card-text">Бесплатно</div>
                </div>
                <div class="app__card-line" />
                <div class="app__card-block app__card-block--3">
                  <div class="app__card-subheader">Срок решения</div>
                  <div class="app__card-text">До 48 часов</div>
                </div>
              </div>
              <div class="app__card6 app__card6--orange">
                <div class="app__card-header">Базовая</div>
                <div class="app__card-block app__card-block--1">
                  <div class="app__card-subheader">Кому предоставляется</div>
                  <div class="app__card-text">Коммерческие пользователи ПО</div>
                </div>
                <div class="app__card-line" />
                <div
                  class="app__card-block app__card-block--2 app__card-block--5"
                >
                  <div class="app__card-subheader">Стоимость</div>
                  <div class="app__card-text">
                    В рамках подписки на обновление ПО действующих лицензий, 20%
                    от общей стоимости лицензии
                  </div>
                </div>
                <div class="app__card-line" />
                <div class="app__card-block app__card-block--3">
                  <div class="app__card-subheader">Срок решения</div>
                  <div class="app__card-text">До 32 часов</div>
                </div>
              </div>
              <div class="app__card6 app__card6--red">
                <div class="app__card-header">Расширенная</div>
                <div class="app__card-block app__card-block--1">
                  <div class="app__card-subheader">Кому предоставляется</div>
                  <div class="app__card-text">Коммерческие пользователи ПО</div>
                </div>
                <div class="app__card-line" />
                <div
                  class="app__card-block app__card-block--2 app__card-block--5"
                >
                  <div class="app__card-subheader">Стоимость</div>
                  <div class="app__card-text">
                    В рамках отдельно заключенного рамочного договора
                  </div>
                </div>
                <div class="app__card-line" />
                <div class="app__card-block app__card-block--3">
                  <div class="app__card-subheader">Срок решения</div>
                  <div class="app__card-text">
                    В соответствии с заключённым договором
                  </div>
                </div>
              </div>
            </div>
          </Wrapper>
        </section>

        <section class="app__section app__section--news">
          <Wrapper>
            <div class="app__grid hidden--grid--narrow">
              <div>
                <div class="app__title">Новости и обновления</div>

                <ul class="app__newses">
                  <li
                    v-for="(news, index) in newsNow"
                    :key="`news--${index}`"
                    class="app__news"
                  >
                    <div class="app__news-info">
                      <div class="app__news-date">{{ news.date }}</div>
                      <div class="app__news-version">{{ news.version }}</div>
                    </div>
                    <div class="app__news-text">{{ news.text }}</div>
                    <div class="app__news-line" />
                  </li>
                </ul>

                <Button
                  v-if="newsNow.length < NEWS.length"
                  size="helike"
                  skin="secondary"
                  is-wide
                  @click.prevent="more"
                  >Показать ещё</Button
                >
              </div>
              <div></div>
              <div>
                <div class="app__title2">Материалы о продукте</div>
                <div>
                  <ButtonAction
                    class="app__material"
                    color="rocky"
                    :link="`./SITE_Digital_Resource_Supply.pdf`"
                    >Презентация о продукте</ButtonAction
                  >
                </div>
                <div>
                  <ButtonAction
                    class="app__material"
                    color="rocky"
                    :link="`./Platform_Brief.pdf`"
                    >Краткое описание</ButtonAction
                  >
                </div>
                <div>
                  <ButtonAction
                    class="app__material app__material--last"
                    color="rocky"
                    :link="`./DRSO_Approved_Licensing_Policy.pdf`"
                    >Политика лицензирования</ButtonAction
                  >
                </div>
                <!--<div>
                  <ButtonAction
                    class="app__material app__material--last"
                    color="rocky"
                    link="#"
                    >Политика конфиденциальности</ButtonAction
                  >
                </div>-->
              </div>
            </div>
            <div class="app__grid visible--block--narrow">
              <div>
                <div class="app__title2">Материалы о продукте</div>
                <div>
                  <ButtonAction
                    class="app__material"
                    color="rocky"
                    :link="`./SITE_Digital_Resource_Supply.pdf`"
                    >Презентация о продукте</ButtonAction
                  >
                </div>
                <div>
                  <ButtonAction
                    class="app__material"
                    color="rocky"
                    :link="`./Platform_Brief.pdf`"
                    >Краткое описание</ButtonAction
                  >
                </div>
                <div>
                  <ButtonAction
                    class="app__material app__material--last"
                    color="rocky"
                    :link="`./DRSO_Approved_Licensing_Policy.pdf`"
                    >Политика лицензирования</ButtonAction
                  >
                </div>
                <!--<div>
                  <ButtonAction
                    class="app__material app__material--last"
                    color="rocky"
                    link="#"
                    >Политика конфиденциальности</ButtonAction
                  >
                </div>-->
              </div>
              <div></div>
              <div>
                <div class="app__title2">Новости и обновления</div>

                <ul class="app__newses">
                  <li
                    v-for="(news, index) in newsNow"
                    :key="`news--${index}`"
                    class="app__news"
                  >
                    <div class="app__news-info">
                      <div class="app__news-date">{{ news.date }}</div>
                      <div class="app__news-version">{{ news.version }}</div>
                    </div>
                    <div class="app__news-text">{{ news.text }}</div>
                    <div class="app__news-line" />
                  </li>
                </ul>

                <Button
                  v-if="newsNow.length < NEWS.length"
                  size="helike"
                  skin="secondary"
                  is-wide
                  @click.prevent="more"
                  >Показать ещё</Button
                >
              </div>
            </div>
          </Wrapper>
        </section>
      </main>

      <template #modals>
        <Modal v-show="modal === 'video'" is-viewport>
          <div class="app__modal-video">
            <video
              id="app__video"
              class="app__modal-video"
              :width="width2"
              :height="height2"
            >
              <source src="./assets/video/full.mp4" type="video/mp4" />
            </video>

            <div class="app__modal-video-wrapper">
              <Button
                class="app__modal-video-close"
                @click.prevent="closeModal()"
                is-icon
              >
                <template #icon>
                  <Icon name="close_16" />
                </template>
                <span>Закрыть</span>
              </Button>

              <ButtonPlayer v-if="!isPlay" @click.prevent="play()" />
            </div>
          </div>
        </Modal>

        <Modal v-show="modal === 'form'">
          <div class="app__modal-title">
            Закажите бесплатную демонстрацию продукта
          </div>
          <div class="app__modal-subtitle">
            Наш менеджер свяжется с Вами, чтобы обсудить детали и договориться
            об удобном времени
          </div>
          <div class="app__modal-form">
            <div class="app__form-grid">
              <div>
                <Input v-model="nickname" placeholder="Как к Вам обращаться" />
              </div>
              <div>
                <Input v-model="phone" placeholder="Номер телефона" is-phone />
              </div>
            </div>
            <div class="app__modal-check">
              <Checkbox
                text="Я предоставляю "
                text2=" и соглашаюсь с условиями "
                v-model="isCheckModal"
              >
                <template #link>
                  <Link
                    text="Согласие на обработку персональных данных"
                    :link="`./Consent_of_Personal_Data_processing.pdf`"
                  />
                </template>
                <template #link2>
                  <Link
                    text="Политики в отношении обработки персональных данных"
                    :link="`./Personal_Data_Processing_Policy.pdf`"
                  />
                </template>
              </Checkbox>
            </div>
            <div class="app__button">
              <Button
                @click.prevent="postForm()"
                size="helike"
                is-wide
                :is-disabled="!isCheckModal"
                >Отправить</Button
              >
            </div>
          </div>
        </Modal>
      </template>

      <template #footer>
        <Footer />
      </template>
    </LayoutSite>

    <div v-if="isPlank" class="app__plank-wrapper">
      <div class="app__plank visible--flex--not-narrow">
        <div class="app__plank-text">
          Нажмите «Принять», если вы соглашаетесь с условиями обработки файлов
          cookie, нужных нам для аналитики на условиях, предусмотренных
          <Link
            text="Политикой в отношении обработки персональных данных"
            :link="`./Personal_Data_Processing_Policy.pdf`"
          />. Запретить обработку cookie вы можете через браузер.
        </div>
        <Button
          class="app__plank-button"
          size="helike"
          skin="secondary"
          @click.prevent="asseptPlank()"
          >Принять</Button
        >
        <ButtonSimple
          skin="transparent"
          size="larishae"
          @click.prevent="closePlank"
        >
          <Icon name="close_20" />
        </ButtonSimple>
      </div>

      <div class="app__plank visible--block--narrow">
        <div class="app__plank-text">
          Нажмите «Принять», если вы соглашаетесь с условиями обработки файлов
          cookie, нужных нам для аналитики на условиях, предусмотренных
          <Link
            text="Политикой в отношении обработки персональных данных"
            :link="`./Personal_Data_Processing_Policy.pdf`"
          />. Запретить обработку cookie вы можете через браузер.
        </div>

        <div class="app__plank-mobile">
          <Button
            class="app__plank-button"
            size="helike"
            skin="secondary"
            @click.prevent="asseptPlank()"
            >Принять</Button
          >
          <ButtonSimple
            skin="transparent"
            size="larishae"
            @click.prevent="closePlank"
          >
            <Icon name="close_20" />
          </ButtonSimple>
        </div>
      </div>
    </div>
  </DS>
</template>

<script lang="ts">
import { useStore } from 'vuex';
import { key } from '@/store';
import 'vue3-carousel/carousel.css';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
import { defineComponent, onMounted, ref, computed, watch } from 'vue';
import vClickOutside from 'click-outside-vue3';

// Types
import { Themes } from '@/utils/constants';

// Utisl
import { ScreenHelper } from '@/utils/constants';

// Content
import { NEWS } from '@/news';

// Components
import DS from '@/components/ds/DS.vue';
import Wrapper from '@/components/ds/Wrapper.vue';
import Button from '@/components/ds/Button.vue';
import Plank from '@/components/ds/Plank.vue';
import LayoutSite from '@/components/ds/LayoutSite.vue';
import Modal from '@/components/ds/Modal.vue';
import ButtonPlayer from '@/components/ds/ButtonPlayer.vue';
import ButtonAction from '@/components/ds/ButtonAction.vue';
import ButtonSimple from '@/components/ds/ButtonSimple.vue';
import Input from '@/components/ds/Input.vue';
import Checkbox from '@/components/ds/Checkbox.vue';
import Icon from '@/components/ds/Icon.vue';
import Link from '@/components/ds/Link.vue';
import Footer from '@/components/Footer.vue';

const screenshotsCarouselConfig = {
  wrapAround: true,
  mouseDrag: {
    threshold: 0.25,
  },
};

const nationalStandardsCarouselConfig = {
  wrapAround: false,
  itemsToShow: 1.4,
  gap: 16,
  mouseDrag: {
    threshold: 0.25,
  },
};

const citiesCarouselconfig = {
  wrapAround: false,
  itemsToShow: 1.8,
  gap: 12,
  mouseDrag: {
    threshold: 0.25,
  },
};

const INFO = 'RSO_LEGAL_INFORMATION_CLOSED';

export default defineComponent({
  name: 'App',

  directives: {
    clickOutside: vClickOutside.directive,
  },

  components: {
    DS,
    Wrapper,
    Button,
    Plank,
    LayoutSite,
    Footer,
    Modal,
    ButtonPlayer,
    ButtonAction,
    Icon,
    Input,
    Checkbox,
    Link,
    Carousel,
    Slide,
    Pagination,
    Navigation,
    ButtonSimple,
  },

  setup() {
    const store = useStore(key);

    const getCookie = (name: string) => {
      let matches = document.cookie.match(
        new RegExp(
          '(?:^|; )' +
            // eslint-disable-next-line no-useless-escape
            name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
            '=([^;]*)',
        ),
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    };

    const setCookie = (name: string, value: string) => {
      let updatedCookie =
        encodeURIComponent(name) + '=' + encodeURIComponent(value);

      document.cookie = updatedCookie;
    };

    let isPlankStart: boolean;
    const kuka = getCookie(INFO);
    if (!kuka || Math.round(Date.now() / 1000) - Number(kuka) > 31556926) {
      isPlankStart = true;
    } else isPlankStart = false;

    console.log(getCookie(INFO));

    let width = ref(0);
    let height = ref(0);
    let width2 = ref(0);
    let height2 = ref(0);
    let slider = ref(0);
    const nickname = ref('');
    const phone = ref('');
    let isMounted = ref(false);
    let isPopup1 = ref(false);
    let isClick = ref(false);
    let isPlay = ref(false);
    let isPlank = ref(isPlankStart);
    let isCheckModal = ref(false);
    let onResize: () => void;
    let setSizes: () => void;
    let setSizes2: () => void;
    let setModal: (name: string) => void;
    let closeModal: () => void;
    let play: () => void;
    let postForm: () => void;
    let more: () => void;
    let onClickOutside: () => void;
    let tryClick: () => void;
    let asseptPlank: () => void;
    let closePlank: () => void;

    let count = ref(4);

    const modal = computed(() => store.getters['layout/modal']);
    const theme = computed(() => store.getters['persist/theme']);
    const isScroll = computed(() => store.getters['layout/isScroll']);
    const newsNow = computed(() => NEWS.slice(0, count.value));

    onMounted(() => {
      window.addEventListener('resize', () => onResize(), false);

      setSizes();
    });

    onResize = () => {
      setSizes();
      setSizes2();
    };

    more = () => {
      count.value += 4;
    };

    setSizes = () => {
      ++slider.value;

      const top = document.getElementById('app__top');
      if (top) {
        if (top.offsetWidth / top.offsetHeight <= 16 / 9) {
          height.value = top.offsetHeight;
          width.value = (top.offsetHeight * 16) / 9;
        } else {
          width.value = top.offsetWidth;
          height.value = (top.offsetWidth * 9) / 16;
        }

        isMounted.value = true;
      }
    };

    setSizes2 = () => {
      setTimeout(() => {
        const modal = document.getElementById('app__modal');
        if (modal) {
          if (ScreenHelper.isDesktops()) {
            if (modal.offsetWidth / modal.offsetHeight <= 16 / 9) {
              height2.value = modal.offsetHeight;
              width2.value = (modal.offsetHeight * 16) / 9;
            } else {
              width2.value = modal.offsetWidth;
              height2.value = (modal.offsetWidth * 9) / 16;
            }
          } else {
            width2.value = modal.offsetWidth;
            height2.value = (modal.offsetWidth * 9) / 16;
          }
        }
      }, 0);
    };

    setModal = (name) => {
      store.dispatch('layout/setLayoutState', {
        field: 'modal',
        value: name,
      });
    };

    closeModal = () => {
      store.dispatch('layout/setLayoutState', {
        field: 'modal',
        value: null,
      });
    };

    postForm = () => {
      store.dispatch('api/postForm', {
        nickname: nickname.value,
        phone: phone.value,
      });
    };

    asseptPlank = () => {
      setCookie(INFO, Math.round(Date.now() / 1000).toString());
      isPlank.value = false;
    };

    closePlank = () => {
      isPlank.value = false;
    };

    play = () => {
      const video = document.getElementById('app__video');
      if (video) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        video.play().then(() => {
          isPlay.value = true;

          video.addEventListener('ended', () => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            video.currentTime = 0;
            isPlay.value = false;
          });
        });
      }
    };

    onClickOutside = () => {
      isPopup1.value = false;
      if (!isClick.value) {
        isClick.value = true;
        isPopup1.value = false;
        setTimeout(() => {
          isClick.value = false;
        }, 250);
      }
    };

    tryClick = () => {
      if (!isClick.value) {
        isClick.value = true;
        isPopup1.value = !isPopup1.value;
        setTimeout(() => {
          isClick.value = false;
        }, 250);
      }
    };

    watch(
      () => modal.value,
      (value) => {
        setSizes2();

        if (!value && isPlay.value) {
          const video = document.getElementById('app__video');
          if (video) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            video.pause();
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            video.currentTime = 0;
            isPlay.value = false;
          }
        }
      },
    );

    return {
      width,
      height,
      width2,
      height2,
      isMounted,
      screenshotsCarouselConfig,
      modal,
      setModal,
      closeModal,
      play,
      isPlay,
      slider,
      isScroll,
      theme,
      Themes,
      postForm,
      nickname,
      phone,
      isPopup1,
      newsNow,
      NEWS,
      more,
      nationalStandardsCarouselConfig,
      citiesCarouselconfig,
      isCheckModal,
      onClickOutside,
      tryClick,
      asseptPlank,
      closePlank,
      isPlank,
    };
  },
});
</script>

<style lang="stylus">
@import "~/src/assets/stylus/main.styl";

// Slider
:root
  --vc-pgn-active-color var(--rocky)
  --vc-pgn-background-color var(--dangal)
  --vc-pgn-height 8px
  --vc-pgn-width 8px
  --vc-pgn-border-radius 4px
  --vc-pgn-margin 2px

.carousel__viewport
  border-radius 10px

.carousel__pagination
  bottom -48px

  +$middle()
    bottom -40px

  +$narrow()
    bottom -36px

.carousel__pagination-button:hover
  color $colors.alien
  color var(--alien)

$padding-section
  padding-top 80px
  padding-bottom 80px

  +$middle()
    padding-top 56px
    padding-bottom 56px

  +$narrow()
    padding-top 40px
    padding-bottom 40px

main
  background $colors.amelie
  background var(--amelie)

.app__card-header--info
  position relative

$name = '.app'

{$name}
  &__video
    object-fit cover

  &__newses
    list-style none
    margin-bottom 32px

    +$gadgets()
      margin-bottom 24px

  &__last-slide
    height 100%
    width 24px

  &__news
    &:last-child
      {$name}__news-line
        display none

    &-info
      display flex
      margin-bottom 8px

    &-date
      margin-right 24px

    &-date,
    &-version
      color $colors.metropolis
      color var(--metropolis)
      $text("mozzarella")

    &-text
      color $colors.troy
      color var(--troy)
      $text("parmigiano")

    &-line
      width 100%
      height 1px
      margin-top 24px
      margin-bottom 24px
      background $colors.casablanca
      background var(--casablanca)

  &__material
    margin-bottom 24px

    &--last
      margin-bottom 40px

  &__section-header
    position relative
    padding-right 359px

    +$gadgets()
      position static
      padding-right 0

  &__section-header-link
    position absolute
    top 12px
    right 0

    +$gadgets()
      position static
      margin-bottom 24px

  &__modal-video
    background $colors.amelie
    background var(--amelie)

    +$gadgets()
      height 100%

  &__modal-video-close
    position absolute
    top 8px
    right 8px

  &__video-button
    width 240px
    background $colors.white
    background var(--white)
    $border-radius("kurza")

    +$narrow()
      width 100%
      margin-top 24px

  &__slider
    margin 0 auto
    background $colors.inception
    background var(--inception)
    $border-radius("kurza")

    +$widest()
      padding 20px
      width 1061px
      height 539px

    +$wide()
      padding 15px
      width 782px
      height 398px

    +$middle()
      padding 10px
      width 536px
      height 272px

    +$narrow()
      padding 6px
      width 100% //313px
      height calc((100vw - 48px) * 158 / 313) // 158px

  &__slide
    +$widest()
      width  1021px
      height 499px

    +$wide()
      width 753px
      height 368px

    +$middle()
      width 528px
      height 254px

    +$narrow()
      width calc((100vw - 48px))
      height calc((100vw - 48px) * 147 / 301 - 4px)

    &--1
      background url('./assets/images/1.png') no-repeat
      background-size cover

    &--2
      background url('./assets/images/2.png') no-repeat
      background-size cover

    &--3
      background url('./assets/images/3.png') no-repeat
      background-size cover

    &--4
      background url('./assets/images/4.png') no-repeat
      background-size cover

    &--5
      background url('./assets/images/5.png') no-repeat
      background-size cover

    &--6
      background url('./assets/images/6.png') no-repeat
      background-size cover

    &--7
      background url('./assets/images/7.png') no-repeat
      background-size cover

    &--8
      background url('./assets/images/8.png') no-repeat
      background-size cover

    &--9
      background url('./assets/images/9.png') no-repeat
      background-size cover

  &__top
    position relative
    color $colors.white
    color var(--white)
    width 100%
    height 100vh
    overflow hidden
    background url('./assets/images/image.png') no-repeat
    background-size cover

    +$middle()
      height calc(100vw * 9 / 16  * 1.25)

    &-wrapper
      @extend $flexCenter
      position absolute
      width 100%
      height 100%
      left 0
      right 0
      top 0
      bottom 0

    &-overlay
      background #0000007A
      position absolute
      width 100%
      height 100%
      left 0
      right 0
      top 0
      bottom 0

    {$name}__title
      color $colors.white
      color var(--white)

  &__title
    margin-bottom 8px
    color $colors.harakiri
    color var(--harakiri)
    $text("cheddar")

    +$narrow()
      $text("ricotta")

  &__subtitle
    color $colors.troy
    color var(--troy)
    margin-bottom 40px
    $text("mascarpone")

    +$narrow()
      $text("parmigiano")

  &__grid
    display grid

  &__text
    margin-bottom 32px
    $text("mascarpone")

  &__wrapper
    width 100%
    position absolute
    left 0
    bottom 0
    padding-bottom 64px

    &-flex
      display flex
      justify-content space-between

      +$narrow()
        display block

    &-outer
      height 100vh
      position relative

      +$middle()
        height calc(100vw * 9 / 16 * 1.25)

  &__color-wrapper-outer
    flex-direction column

  &__color-wrapper-inner
    display inline-block
    margin 0 auto

  &__color-wrapper
    text-align center

    & + {$name}__color-wrapper
      margin-top 16px

      +$middle()
        margin-top 8px

      +$narrow()
        margin-top 8px

  &__color-block
    display inline-block
    vertical-align top
    height 96px
    $text("taleggio")

    > div
      @extend $flexCenter
      width 100%
      height 100%
      text-align center
      background $colors.amelie
      background var(--amelie)
      $border-radius("geban")

    +$middle()
      height 72px
      $text("bryndza")

    +$narrow()
      height 64px
      $text("roquefort")

    &--1
      width 343px
      margin-right 16px

      +$middle()
        width 268px
        margin-right 0

      +$narrow()
        width 239px
        margin-right 0

    &--2
      width 380px
      margin-right 16px

      +$wide()
        margin-right 0

      +$middle()
        width 299px
        margin-right 0

      +$narrow()
        width 249px
        margin-right 0

    &--3
      width 166px

      +$wide()
        margin-right 16px

      +$middle()
        width 125px
        margin-right 8px

      +$narrow()
        width 125px
        margin-right 0

    &--4
      width 464px
      margin-right 16px

      +$wide()
        margin-right 0

      +$middle()
        width 365px
        margin-right 0

      +$narrow()
        width 201px
        margin-right 0

    &--5
      width 418px

      +$middle()
        width 331px

      +$narrow()
        width 273px

    &--6
      width 477px
      margin-right 16px

      +$wide()
        margin-right 0

      +$middle()
        width 381px
        margin-right 0

      +$narrow()
        height 80px
        width 211px
        margin-right 0

    &--7
      width 653px

      +$middle()
        height 92px
        width 401px

      +$narrow()
        width 251px
        height 96px

    &--8
      width 663px
      height 92px
      margin-right 16px

      +$wide()
        margin-right 0

      +$middle()
        width 429px
        margin-right 0

      +$narrow()
        margin-right 0
        width 251px
        height 96px

    &--9
      width 244px

      +$middle()
        width 189px

      +$narrow()
        width 189px
        height 64px

  &__color
    @extend $flexCenter
    width 100%
    height 100%

    &--1
      background url('./assets/images/bg_wide.svg') no-repeat
      background-size cover
      border-radius 64px

      +$middle()
        background url('./assets/images/bg_middle.svg') no-repeat

      +$narrow()
        background url('./assets/images/bg_narrow.svg') no-repeat

    &--2
      background url('./assets/images/bg_wide-2.svg') no-repeat
      background-size cover
      border-radius 64px

      +$wide()
        height 560px

      +$middle()
        background url('./assets/images/bg_middle-2.svg') no-repeat

      +$narrow()
        background url('./assets/images/bg_narrow-2.svg') no-repeat

  &__arrow-left
    transform translateX(-42px)

    +$wide()
      transform translateX(-38px)

    +$middle()
      transform translateX(-32px)

    +$narrow()
      transform translateX(-30px)

  &__arrow-right
    transform translateX(42px)

    +$wide()
      transform translateX(38px)

    +$middle()
      transform translateX(32px)

    +$narrow()
      transform translateX(30px)

  &__arrow-left,
  &__arrow-right
    @extend $mediumShadow
    border-radius 50%

  &__popup
    width 218px
    position absolute
    left 0
    top 0
    transform translateY(-50%) translateX(100%)
    padding 16px
    background $colors.amelie
    background var(--amelie)
    color $colors.troy
    color var(--troy)
    $text("zamorano")
    $border-radius("kurza")

    +$narrow()
      transform translateY(-100%) translateX(30%)

  &__not-map
    position relative

  &__map
    z-index 0
    position absolute
    top 40px
    left 0
    right 0
    width 100%
    height 804px
    background url('./assets/images/map_not-narrow.svg') center 40px no-repeat

    +$narrow()
      background url('./assets/images/map_narrow.svg') center 36px no-repeat

    &--dark
      background url('./assets/images/map_not-narrow_dark.svg') center 40px no-repeat

      +$narrow()
        background url('./assets/images/map_narrow_dark.svg') center 80px no-repeat

  &__subheader
    color $colors.metropolis
    color var(--metropolis)
    margin-bottom 16px
    $text("mozzarella")

  &__section
    background $colors.amelie
    background var(--amelie)

    &--color
      height 336px
      background-size cover

      > div
        height 100%
        color $colors.harakiri
        color var(--harakiri)

    &--color1
      padding-top 80px

      +$wide()
        height 448px

      +$middle()
        height 472px

      +$narrow()
        height 528px

    &--color2
      padding-top 0

      +$wide()
        height 560px

      +$middle()
        height 432px

      +$narrow()
        height 440px

    &--dev
      @extend $flexCenter
      height 700px
      text-align center

      +$narrow()
        height 400px

    &--product
      @extend $padding-section

      {$name}__grid
        grid-gap 12px
        grid-auto-flow column
        grid-template-columns repeat(3, 1fr)
        grid-template-rows repeat(2, 1fr)

        +$middle()
          grid-template-columns repeat(2, 1fr)
          grid-template-rows repeat(3, 1fr)

        +$narrow()
          grid-template-columns repeat(1, 1fr)
          grid-template-rows repeat(6, 1fr)

    &--news
      padding-top 80px
      padding-bottom 164px

      +$wide()
        padding-top 42px
        padding-bottom 132px

      +$middle()
        padding-top 56px
        padding-bottom 156px

      +$narrow()
        padding-top 40px
        padding-bottom 100px

      {$name}__grid
        grid-gap 32px
        grid-template-columns 6fr 1fr 3fr

        +$middle()
          grid-template-columns 3fr 0fr 3fr

        +$narrow()
          display block

      {$name}__title
        margin-bottom 32px
        $text("camembert")

        +$gadgets()
          margin-bottom 24px

      {$name}__title2
        color $colors.harakiri
        color var(--harakiri)
        margin-bottom 24px
        $text("taleggio")

        +$narrow()
          $text("ricotta")

    &--individual
      position relative
      background transparent
      padding-top 140px

      +$middle()
        padding-top 80px

      +$narrow()
        padding-top 56px

      {$name}__title
        margin-bottom 40px

        +$gadgets()
          margin-bottom 24px

      {$name}__grid
        grid-gap 32px
        grid-auto-flow column
        grid-template-columns repeat(3, 1fr)
        grid-template-rows repeat(1, 1fr)

        +$gadgets()
          grid-gap 16 px
          grid-auto-flow row
          grid-template-columns repeat(1, 1fr)

    &--map
      position relative
      padding-top 140px

      +$middle()
        padding-top 80px

      +$narrow()
        padding-top 40px

      .carousel__track > li:first-child
        padding-left 24px

      .carousel__track > li:last-child
         padding-right 24px

      .carousel__track > li
        height 192px
        padding-top 36px
        padding-bottom 36px

      .carousel__pagination
       bottom -16px

      {$name}__card5-header3
        margin-bottom 4px

      {$name}__card5
        width 100%
        text-align left
        height 136px

      {$name}__subtitle
        margin-bottom 60px

        +$narrow()
          margin-bottom 20px

      {$name}__grid
        grid-gap 12px
        grid-auto-flow column
        grid-template-columns repeat(5, 1fr)
        grid-template-rows repeat(1, 1fr)

        +$middle()
          grid-gap 12px
          grid-template-columns repeat(3, 1fr)
          grid-template-rows repeat(3, 1fr)

        +$narrow()
          grid-gap 12px
          grid-template-columns repeat(1, 1fr)
          grid-template-rows repeat(9, 1fr)

        & + {$name}__grid
          margin-top 40px

    &--support
      +$widest()
        padding-top 80px

      +$wide()
        padding-top 35px

      +$middle()
        padding-top 56px

      +$narrow()
        padding-top 40px

      {$name}__title
        margin-bottom 8px

      {$name}__subtitle
        margin-bottom 40px

        +$gadgets()
          margin-bottom 16px

      {$name}__grid
        grid-gap 32 px
        grid-auto-flow column
        grid-template-columns repeat(3, 1fr)
        grid-template-rows repeat(1, 1fr)

        +$gadgets()
          grid-gap 16px
          grid-template-columns repeat(1, 1fr)
          grid-template-rows repeat(3, 1fr)

    &--clients
      background $colors.amelie
      background var(--amelie)
      padding-top 80px
      padding-bottom 64px

      +$middle()
        padding-top 56px
        padding-bottom 56px

      +$narrow()
        padding-top 40px
        padding-bottom 40px

      {$name}__title
        margin-bottom 40px

        +$gadgets()
          margin-bottom 24px

      {$name}__grid
        grid-gap 32px
        grid-auto-flow column
        grid-template-columns repeat(3, 1fr)
        grid-template-rows repeat(1, 1fr)

        +$gadgets()
          grid-gap 24px
          grid-template-columns repeat(1, 1fr)
          grid-template-rows repeat(3, 1fr)

    &--national
      background $colors.trainspotting
      background var(--trainspotting)
      padding-top 64px
      padding-bottom 64px

      .carousel__track > li:first-child
        padding-left 24px

      .carousel__track > li:last-child
        padding-right 24px

      {$name}__title
        margin-bottom 40px

        +$gadgets()
          margin-bottom 24px

      {$name}__grid--1
        margin-bottom 64px
        grid-gap 32px
        grid-auto-flow column
        grid-template-columns repeat(4, 1fr)
        grid-template-rows repeat(1, 1fr)

        +$middle()
          margin-bottom 40px
          grid-gap 16px
          grid-template-columns repeat(2, 1fr)
          grid-template-rows repeat(2, 1fr)

      {$name}__grid--2
        grid-gap 32px
        grid-auto-flow column
        grid-template-columns repeat(3, 1fr)
        grid-template-rows repeat(1, 1fr)

        +$gadgets()
          grid-gap 24px
          grid-template-columns repeat(1, 1fr)
          grid-template-rows repeat(3, 1fr)

        +$narrow()
          margin-top 40px

    &--possibilities
      @extend $padding-section

      {$name}__grid--1
        margin-bottom 12px
        grid-gap 12px
        grid-auto-flow column
        grid-template-columns repeat(4, 1fr)
        grid-template-rows repeat(1, 1fr)

        +$middle()
          grid-template-columns repeat(2, 1fr)

        +$narrow()
          grid-template-columns repeat(1, 1fr)
          grid-template-rows repeat(3, 1fr)

      {$name}__grid--2
        grid-gap 12px
        grid-auto-flow column
        grid-template-columns repeat(3, 1fr)
        grid-template-rows repeat(1, 1fr)

        +$middle()
          grid-template-columns repeat(2, 1fr)
          grid-template-rows repeat(2, 1fr)

        +$narrow()
          grid-template-columns repeat(1, 1fr)
          grid-template-rows repeat(4, 1fr)

      {$name}__title
        margin-bottom 40px

        +$gadgets()
          margin-bottom 24px

  &__card2
    background $colors.amelie
    background var(--amelie)
    padding 20px
    $border-radius("kurza")

    &--in-slide
      height 312px

  &__card3
    background transparent

  &__card,
  &__card4
    background $colors.trainspotting
    background var(--trainspotting)

  &__card,
  &__card4,
  &__card5,
  &__card6
    padding 20px
    $border-radius("kurza")

    &-tag
      margin-bottom 4px
      color $colors.rocky
      color var(--rocky)
      $text("mozzarella")

    &-info
      overflow visible
      position relative
      margin-left 8px
      transform translateY(5px)

    &-header
      display flex
      margin-bottom 8px
      color $colors.harakiri
      color var(--harakiri)
      $text("taleggio")

    &-header2
      margin-bottom 12px
      color $colors.harakiri
      color var(--harakiri)
      font-size 16px
      line-height 20px
      font-weight $font-weight.medium

    &-header3
      margin-bottom 12px
      color $colors.harakiri
      color var(--harakiri)
      $text("bryndza")

    &-subheader
      color $colors.metropolis
      color var(--metropolis)
      margin-bottom 8px
      $text("mozzarella")

    &-text
      color $colors.troy
      color var(--troy)
      font-size 16px
      line-height 24px
      font-weight $font-weight.regular

    &-text2
      color $colors.metropolis
      color var(--metropolis)
      $text("parmigiano")

    &-logo
      @extend $flexCenter
      width 56px
      height 56px
      border-radius 50%
      margin-top -48px
      margin-bottom 12px

      &--1
        background $colors.snatch
        background var(--snatch)

        > div
          width 39px
          height 32px
          background url('./assets/images/logo1.png') center center no-repeat
          background-size cover

      &--2
        background $colors.indiana
        background var(--indiana)

        > div
          width 36px
          height 32px
          background url('./assets/images/logo2.png') center center no-repeat
          background-size cover

      &--3
        background $colors.snatch
        background var(--indiana)

        > div
          width 36px
          height 32px
          background url('./assets/images/logo3.png') center center no-repeat
          background-size cover

      &--4
        background $colors.alien
        background var(--alien)

        > div
          width 24px
          height 32px
          background url('./assets/images/logo4.png') center center no-repeat
          background-size cover

      &--5
        background $colors.memento
        background var(--memento)

        > div
          width 26px
          height 32px
          background url('./assets/images/logo5.png') center center no-repeat
          background-size cover

      &--6
        background $colors.indiana
        background var(--indiana)

        > div
          width 24px
          height 32px
          background url('./assets/images/logo6.png') center center no-repeat
          background-size cover

      &--7
        background $colors.alien
        background var(--alien)

        > div
          width 28px
          height 32px
          background url('./assets/images/logo7.png') center center no-repeat
          background-size cover

      &--8
        background $colors.indiana
        background var(--indiana)

        > div
          width 26px
          height 32px
          background url('./assets/images/logo8.png') center center no-repeat
          background-size cover

      &--9
        background $colors.memento
        background var(--memento)

        > div
          width 32px
          height 32px
          background url('./assets/images/logo9.png') center center no-repeat
          background-size cover

    &-icon
      margin-bottom 16px

    &-icon2
      margin-bottom 32px

      +$gadgets
        margin-bottom 16px

    &-list
      margin-top 16px
      padding-left 28px
      list-style none

      > li
        position relative
        margin-bottom 8px
        color $colors.troy
        color var(--troy)
        $text("parmigiano")

        &:before
          content ""
          position absolute
          left -28px
          top 4px
          width 16px
          height 16px
          background url('./assets/svg/item.svg') no-repeat

  &__card4
    position relative
    padding-left 28px
    overflow hidden

    &:before
      content ""
      position absolute
      width 8px
      height 100%
      top 0
      left 0
      bottom 0

    &--blue
       &:before
        background $colors.alien
        background var(--alien)

    &--orange
       &:before
        background $colors.snatch
        background var(--snatch)

    &--red
       &:before
        background $colors.indiana
        background var(--indiana)

  &__card5
    @extend $bigShadow
    background $colors.amelie
    background var(--amelie)

  &__card6
    position relative
    overflow hidden

    &:before
      content ""
      position absolute
      left 0
      right 0
      top 0
      bottom 0
      width 100%
      height 100%
      z-index 0
      $opacity("dere")

    {$name}__card
      &-text
        $text("feta")

      &-header
        position relative
        margin-bottom 16px

      &-subheader
        position relative
        margin-bottom 4px

      &-line
        position relative
        width 100%
        height 1px
        margin-top 16px
        margin-bottom 16px
        background $colors.harakiri
        background var(--harakiri)
        $opacity("dere")

      &-block
        &--1
          height 60px

          +$wide()
            height auto

          +$gadgets()
            height auto

        &--2
          height 80px

          +$wide()
            height auto

          +$gadgets()
            height auto

        &--3
          height 40px

          +$wide()
            height auto

          +$gadgets()
            height auto

        &--4
          +$wide()
            height 100px

        &--5
          +$wide()
            height 120px

    &--blue:before
      background $colors.rocky
      background var(--rocky)

    &--orange:before
      background $colors.lebowski
      background var(--lebowski)

    &--red:before
      background $colors.fargo
      background var(--fargo)

  &__modal-video-wrapper
    @extend $flexCenter
    position absolute
    width 100%
    height 100%
    left 0
    right 0
    top 0
    bottom 0

  &__modal-title
    color $colors.harakiri
    color var(--harakiri)
    margin-bottom 16px
    $text("camembert")

    +$narrow()
      $text("burrata")

  &__modal-subtitle
    color $colors.troy
    color var(--troy)
    margin-bottom 24px
    $text("parmigiano")

  &__modal-form
    // margin-bottom 24px

  &__modal-check
    margin-bottom 32px

  &__form-grid
    margin-bottom 24px
    > div
      display inline-block
      vertical-align top

      &:first-child
        width 512px
        margin-right 32px

        +$wide()
          width 372px

        +$gadgets()
          width 100%
          margin-bottom 24px

      &:last-child
        width 296px

        +$wide()
          width 212px

        +$gadgets()
          width 100%

.app__subtitle
  +$middle()
    font-size 16px
    line-height 24px

.app__card-header2
  +$middle()
    font-size 13px
    line-height 16px

.app__card-text,
.app__card-text2,
.app__card6 .app__card-text,
.app__card-list > li,
.app__news-text
  +$middle()
    font-size 10px
    line-height 12px

.app__grid--3
  margin-bottom 12px

.app__plank-wrapper
  position fixed
  z-index 99999
  width 100%
  height auto
  bottom 32px
  left 0
  right 0

  +$gadgets()
    bottom 24px

.app__plank
  @extend $bigShadow
  display flex
  margin 0 auto
  border-radius 16px
  background $colors.amelie
  background var(--amelie)
  width 1061px
  height 72px
  padding 16px
  color $colors.harakiri
  color var(--harakiri)
  align-items center
  $text("briscola")

  +$wide()
    width 782px
    height 92px
    left 81px
    right 81px

  +$gadgets()
    height auto

  +$middle()
    width calc(100% - 64px)
    left 32px
    right 32px

  +$narrow()
    width calc(100% - 48px)
    left 24px
    right 24px

.app__plank-text,
.app__plank-button
  margin-right 16px

.app__plank-mobile
  display flex
  margin-top 16px
</style>
